import { GET_BAG } from "./constants";

export { getBag, getBagItems, getTotalQuantity, getUpdated } from "./selectors";
export { getBagFromSDK } from "./actions";

const initialState = {
  isOpen: false,
  bag: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BAG:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./template/state/modules/miniBag/index.js